{
  "common": {
    "LoginPage.login-header": "Log in",
    "LoginPage.login-btn": "Log in",
    "login": "Login",
    "LoginPage.login.required": "Login is required",
    "LoginPage.password": "Password",
    "LoginPage.password.required": "Password is required",
    "LoginPage.rememberMe": "Remember me",
    "LoginPage.loginFailed": "Wrong login or password",
    "LoginPage.restorePassword": "Forgotten password",
    "LoginPage.acceptRegulation": "By logging in to the platform, you agree to abide by the terms and conditions and rules of use of the service",
    "ActivatePage.header": "Account activation",
    "ActivatePage.password": "Password",
    "ActivatePage.confirmPassword": "Confirm password",
    "ActivatePage.button": "Activate",
    "ActivatePage.activationFailed": "Account activation failed",
    "ActivatePage.passwordRequired": "Password is required.",
    "ActivatePage.confirmPasswordRequired": "Confirm Password is required.",
    "ActivatePage.confirmPasswordMatch": "Confirm Password does not match.",
    "ActivatePage.passwordRequirements": "Password must be at least 8 characters long and include at least one uppercase letter (A-Z), one lowercase letter (a-z), one number (0-9), and one special character (!@#$%^&*).",
    "ResetPasswordPage.header": "Password change",
    "ResetPasswordPage.password": "Password",
    "ResetPasswordPage.confirmPassword": "Confirm password",
    "ResetPasswordPage.button": "Change password",
    "resetPassword": "Reset password",
    "resetPasswordSuccessful": "Password successfully reset",
    "ResetPasswordPage.resetPasswordFailed": "Password change failed",
    "RestorePasswordPage.header": "Restore password",
    "RestorePasswordPage.button": "Restore password",
    "RestorePasswordPage.restorePasswordFailed": "Restore password failed",
    "RestorePassword.backToLogin": "Back to login",
    "OrganizationUsers.addAccount": "New account",
    "add": "Add",
    "name": "Name",
    "town": "Town",
    "OrganizationUsers.addAccount.name.required": "Enter user's name",
    "OrganizationUsers.addAccount.login.required": "Enter user's login",
    "OrganizationUsers.addAccount.email.required": "Enter user's email",
    "OrganizationUsers.addAccount.email.format": "Enter valid email",
    "OrganizationUsers.deleteAccount": "Delete account",
    "OrganizationUsers.editAccount.dialogTitle": "Edit account",
    "OrganizationUsers.addAccount.dialogTitle": "Create new user",
    "OrganizationUsers.managesUsers": "Manages users",
    "OrganizationUsers.assignsProjectNumber": "Assigns project number",
    "OrganizationUsers.viewsUnassignedProjects": "Views unassigned projects",
    "all": "All",
    "ALL": "All",
    "company": "Company",
    "Companies.clients": "Clients",
    "Companies.subcontractors": "Subcontractors",
    "active": "Active",
    "inactive": "Inactive",
    "Companies.addNew": "Add new",
    "Companies.AddCompany.header": "Add new company",
    "Companies.CompanyView.companyClientInfo": "Client's info",
    "Companies.CompanyView.companySubcontractorInfo": "Subcontractor's Info",
    "Maps.clients": "Clients map",
    "Maps.clients.clientsAndBranches": "Clients and branches",
    "Maps.clients.headquarters": "Clients' headquarters",
    "Maps.subcontractors": "Subcontractors map",
    "Maps.subcontractors.collectingAndTransportingSubjects": "Collecting and transporting entities",
    "Maps.subcontractors.collectingSubjects": "Collecting entities",
    "Maps.subcontractors.transportingSubjects": "Transporting entities",
    "branch": "Branch",
    "companyBranch": "Company branch",
    "branchName": "Branch name",
    "branchName.break": "Branch</br>name",
    "branches": "Branches",
    "Companies.CompanyView.infrastructure": "Infrastructure",
    "file": "File",
    "files": "Files",
    "otherFiles": "Other files",
    "Companies.CompanyView.CompanyInfo.companyDataHeader": "Company information",
    "Companies.CompanyView.CompanyInfo.correspondenceDataHeader": "Correspondence data",
    "addNewBranch": "Create new branch",
    "Companies.CompanyView.CompanyBranches.header": "Company branches",
    "Companies.CompanyView.CompanyBranches.ViewCompanyBranch.AddCompanyBranch.header": "New branch",
    "Companies.CompanyView.CompanyBranches.ViewCompanyBranch.CompanyBranchData.registrationAddress.header": "Registration address",
    "Companies.CompanyView.CompanyFiles.commercial.viewFile": "Show document",
    "viewFile": "Show file",
    "showFiles": "Show files",
    "uploadFile": "Upload a file",
    "fileName": "File name",
    "dragAndDropAFile": "Drag and drop a file",
    "Projects.header": "List of projects",
    "Projects.addNew": "Add project",
    "Projects.AddProject.header": "Add new project",
    "Projects.AddProjectInfrastructure.header": "Add infrastructure to project",
    "Projects.ViewProject.projectsTab": "Project",
    "client": "Client",
    "clients": "Client's",
    "subcontractors": "Subcontractors",
    "Projects.ViewProject.dictionaryTab": "Dictionary",
    "Projects.ViewProject.Dictionary.Waste.waste": "Select waste",
    "Projects.ViewProject.termsTab": "Terms",
    "Projects.ViewProject.pricesTab": "Set prices",
    "Projects.ViewProject.pricesTab.button": "Change service prices",
    "priceChangeDate": "Date of the price change",
    "changePrices": "Change prices",
    "changePrice": "Change price",
    "selectSubcontractor": "Choose a subcontractor",
    "selectServiceType": "Select type of service",
    "selectWasteCode": "Select waste code",
    "service": "Service",
    "serviceType": "Service type",
    "serviceType.SCHEDULED": "Scheduled",
    "SCHEDULED": "Scheduled",
    "serviceType.PER_REQUEST": "Per request",
    "PER_REQUEST": "Per request",
    "serviceType.ADDITIONAL": "Additional",
    "ADDITIONAL": "Additional",
    "serviceType.COMMUNE": "Commune",
    "COMMUNE": "Commune",
    "selectInfrastructureResource": "Select an infrastructure resource",
    "selectHeadquarters": "Select headquarters",
    "oldPrice": "Old price",
    "oldPriceReceival": "Old price Pick up Client",
    "newPriceReceival": "New price Pick up Client",
    "oldPriceTransport": "Old price Transport Client",
    "newPriceTransport": "New price Transport Client",
    "revenueOrIS": "Cost description",
    "isRevenue": "IZ revenue",
    "isCost": "IZ cost",
    "revenue": "Revenue",
    "cost": "Cost",
    "pricePerUnit": "Price per unit",
    "declaredSum": "Declared unit sum",
    "declared": "Declared",
    "declare": "Declare",
    "declaredPrice": "Price resulting from the declaration",
    "declaredTransports": "Number of collections per month from the declaration",
    "monthsCount": "Number of months to pay",
    "totalPrice": "Total price",
    "infrastructure": "Infrastructure",
    "Projects.ViewProject.Dictionary.wasteTab": "Waste",
    "Projects.ViewProject.Terms.General.settings": "AGREEMENT SETTINGS",
    "organization": "Interzero",
    "organizationServices": "INTERZERO SERVICES",
    "Projects.ViewProject.Terms.General.interserohSide": "Interzero is party to the agreement",
    "Projects.ViewProject.Terms.General.mass": "Allowable incompatibility of mass",
    "Projects.ViewProject.Terms.General.rsi": "RSI",
    "Projects.ViewProject.Terms.General.counselling": "Counselling",
    "Projects.ViewProject.Terms.General.packing": "Packing",
    "Projects.ViewProject.Terms.General.poi": "POI",
    "Projects.ViewProject.Terms.General.machineService": "Machine service",
    "Projects.ViewProject.Terms.General.employeeOutsourcing": "Employee outsourcing",
    "Projects.ViewProject.Terms.Settings.mainSettings": "Project main settings",
    "Projects.ViewProject.Terms.Settings.declaration": "Acceptance of declaration changes",
    "Projects.ViewProject.Terms.Settings.newServices": "New services doesn't require client's administrator approval",
    "Projects.ViewProject.Terms.Settings.branchReports": "Branch is allowed to generate financial reports",
    "Projects.ViewProject.Terms.Settings.clientAdminReports": "Client Administrator see pickups",
    "Projects.ViewProject.Terms.Settings.assetsRequest": "Request to receive assets",
    "Projects.ViewProject.Terms.Settings.ISAdmin": "IZ Administrator",
    "Projects.ViewProject.Terms.Settings.clientAdmin": "Client's Administrator",
    "Projects.ViewProject.Terms.Settings.clientBranch": "Client's Branch",
    "regionalAdmin": "Regional Administrator",
    "Projects.ViewProject.Terms.Settings.headquarters": "Headquarters name",
    "Projects.ViewProject.Terms.Settings.dpr": "DPR request",
    "Projects.ViewProject.Terms.Settings.declarationISAdmin": "Accept. of declaration changes: IZ Administrator",
    "Projects.ViewProject.Terms.Settings.declarationClientAdmin": "Accept. of declaration changes: Client's Administrator",
    "Projects.ViewProject.Terms.Settings.declarationClientBranch": "Accept. of declaration changes: Client's Branch",
    "Projects.ViewProject.Terms.Settings.declarationRegionalAdmin": "Accept. of declaration changes: Regional Administrator",
    "Projects.ViewProject.Terms.Pix.averageEUR": "Average value of EUR in the month preceding performance of the service",
    "Projects.ViewProject.Terms.Pix.addValue": "Add new value subtracted from PIX",
    "month": "Month",
    "twoMonths": "2 Months",
    "threeMonths": "3 Months",
    "sixMonths": "6 Months",
    "Projects.ViewProject.Terms.Pix.pixRate": "PIX rate value",
    "Projects.ViewProject.Terms.Pix.subtractedValue": "Value subtracted from PIX",
    "validFrom": "Valid from",
    "validUntil": "Valid until",
    "Projects.ViewProject.Terms.Pix.eurPayoff": "EUR exchange rate payoff",
    "Projects.ViewProject.Terms.Pix.pixPayoff": "PIX rate payoff",
    "vatin": "OIB",
    "Projects.ViewProject.Client.HeadquartersBranches": "Headquarters and Branches",
    "addAllBranches": "Add all branches",
    "addCentral": "Add central as branch",
    "addCompany": "Add company",
    "addBranch": "Add company branch",
    "exportToExcel": "Export to Excel",
    "Projects.ViewProject.Client.HeadquartersBranches.headquartersName": "Headquarters Name",
    "Projects.ViewProject.Client.HeadquartersBranches.branchesAmount": "Branches amount",
    "postcode": "Postcode",
    "locality": "Locality",
    "street": "Street",
    "creationDate": "Creation date",
    "Projects.ViewProject.Client.HeadquartersBranches.agreement": "Agreement",
    "Projects.ViewProject.Client.HeadquartersBranches.mpd": "MPD ",
    "Projects.ViewProject.Client.Agreements.ClientAgreements": "Client Agreements",
    "Projects.ViewProject.Client.Agreements.shared": "Shared",
    "Projects.ViewProject.Client.Agreements.validFrom": "Valid from",
    "forUnlimitedPeriod": "For an unlimited period",
    "Projects.ViewProject.Client.Agreements.validUntil": "Valid until",
    "noticePeriod": "Notice period",
    "comment": "Comment",
    "options": "Options",
    "additionalDescription": "Additional description",
    "added": "Added",
    "addedBy": "Added by",
    "introducedBy": "Introduced by",
    "subcontractorsName": "Subtractor's name",
    "contact": "Contact",
    "firstName": "First name",
    "lastName": "Last name",
    "phone": "Phone",
    "phoneNumber": "Phone number",
    "email": "Email",
    "orderEmails": "Order emails",
    "mainContactPerson": "Main contact person",
    "otherContactPersons": "Other contact persons",
    "contactPersons": "Contact persons",
    "contactPersonsInterzero": "Interzero carer",
    "userAccounts": "User Accounts",
    "user": "User",
    "users": "Users",
    "Projects.ViewProject.Client.UserAccounts.addUser": "Add user",
    "admin": "Administrator",
    "Projects.ViewProject.Client.UserAccounts.addAdmin": "Add administrator",
    "regionalAdmins": "Regional Administrators",
    "Projects.ViewProject.Client.UserAccounts.addRegionalAdmin": "Add Regional Administrator",
    "lastLogin": "Last login date",
    "schedule": "Schedule",
    "scheduleType": "Schedule type",
    "scheduleType.STATIC": "Static",
    "scheduleType.DYNAMIC": "Dynamic",
    "onDemand": "On demand",
    "report": "Report",
    "reports": "Reports",
    "commune": "Commune",
    "communes": "Communes",
    "district": "District",
    "additional": "Additional",
    "globalReports": "Global reports",
    "assignedBranches": "Assigned branches",
    "Projects.ViewProject.infrastructureServices": "Infrastructure Services",
    "Projects.ViewProject.services": "Services",
    "projectNumber": "Project number",
    "Projects.ViewProject.copy": "Copy",
    "Projects.ViewProject.acceptance": "Acceptance",
    "Projects.ViewProject.acceptedNotActive": "BORE ACTIVATION DATE",
    "Projects.ViewProject.acceptedNotActiveTooltip": "Service is waiting for its start day",
    "accept": "Accept",
    "sendToAcceptance": "Send for approval",
    "removeAcceptance": "Remove acceptance",
    "editedBy": "Edited by",
    "Projects.ViewProject.add": "Add",
    "createdBy": "Created by",
    "lastModified": "Last modified",
    "lastModifiedFiles": "Last modification of files",
    "variableAnnotation": "Variable Annotation",
    "emailForApplication": "Email for application",
    "settlementUnit": "Settlement unit",
    "settlementUnit.MG": "By weight (t)",
    "settlementUnit.UNIT": "By quantity (units)",
    "settlementUnit.M3": "By quantity (m3)",
    "Projects.ViewProject.clientCollectionPrice": "Client Collection",
    "Projects.ViewProject.subcontractorCollectionPrice": "Subcontractor Collection",
    "collectionPrice": "Collection price",
    "Projects.ViewProject.clientTransportPrice": "Client Transport",
    "clientTransport": "Client - transport",
    "clientCollection": "Client - collection",
    "Projects.ViewProject.subcontractorTransportPrice": "Subcontractor Transport",
    "subcontractorTransport": "Subcontractor - transport",
    "transportPrice": "Transport price",
    "subcontractorCollection": "Subcontractor - collection",
    "subcontractorRoleTransporting": "Transporting",
    "subcontractorRoleReceiving": "Middleman / broker",
    "subcontractorRoleTakingOver": "Taking over",
    "subcontractorRoleOther": "Other",
    "subcontractorRoleReceivingCommunalWaste": "Receiving communal waste",
    "paymentMethodCode": "Payment method code",
    "paymentMethodCode.PREPAYMENT": "Prepayment",
    "paymentMethodCode.TRANSFER": "Transfer",
    "separatedInvoice": "Seperated invoice",
    "invoicingMethod": "Invoicing method",
    "invoicingMethod.PER_MONTH": "Per month",
    "invoicingMethod.PER_COLLECTION": "Per collection",
    "constantCost": "Constant cost",
    "organizationAsSide": "IZ is a side of the contract",
    "organizationAsSideShortened": "IZ is a side",
    "reactionTime": "Reaction time, days",
    "reactionTimeForClient": "Reaction time",
    "settledSubcontractorName": "Subcontractor name (to be settled)",
    "settledSubcontractorNameShortened": "SETTLED SUB.",
    "navResource": "BC resource",
    "navResourceNumber": "BC resource number",
    "servicePixRelated": "Service related to PIX",
    "navResourceName": "BC resource name",
    "serviceDesc": "Service description",
    "activationDate": "Activation date",
    "deactivationDate": "Deactivation date",
    "deactivationDateAfterActivationDateRequired": "Deactivation date must be set after activation date",
    "activeFromDateBeforeActivationDateRequired": "Start date must be set after activation date",
    "acceptanceDate": "Acceptance date",
    "Projects.ViewProject.expand": "Expand",
    "Projects.ViewProject.collapse": "Collapse",
    "Projects.ViewProject.serviceDeactivated": "SERVICE DEACTIVATED",
    "Projects.ViewProject.serviceActivated": "SERVICE ACTIVE",
    "Projects.ViewProject.reactivate": "REACTIVATE",
    "Projects.ViewProject.serviceForApproval": "SERVICE FOR APPROVAL",
    "Projects.ViewProject.serviceWaitingForApproval": "SERVICE WAITING FOR APPROVAL",
    "Projects.ViewProject.serviceRejected": "SERVICE REJECTED",
    "Projects.ViewProject.deactivate": "DEACTIVATE",
    "reactivate": "Reactivate",
    "deactivate": "Deactivate",
    "copy": "Copy",
    "copyServiceToAnotherBranches": "Copy to other branches",
    "copyServiceToAnotherBranchesDescription": "This process copies the service to selected branches within the project along with prices, schedule and other settings, as well as infrastructure services related to the service.",
    "copyServiceToAnotherBranchesDialogInfo": "After clicking 'Save', the process of copying will start. This means the button to copy will be disabled, and a circle to the right of it will turn red. The system will copy the infrastructure for this service into a new service or use already copied infrastructure for a similar service. This means that if we have two services with the same infrastructure inside the same branch, the system will create two copies of the services and one copy of the infrastructure. After finishing the process, the button will be available again with a green alert circle.",
    "pix": "PIX",
    "monthlyPixRate": "Monthly PIX rate",
    "monthlyEurPrice": "Monthly Euro price",
    "fixedPixRate": "Fixed PIX rate",
    "number": "Number",
    "sharedInfrastructureId": "Shared infrastructure ID",
    "forUtilization": "For utilization",
    "settledTransportEntity": "Transport entity (to be settled)",
    "settledTransportEntityShortened": "SETTLED TRANS.",
    "CARD_ACCEPTED": "Accepted",
    "CARD_PLANNED": "Planned",
    "LINK_TO_SUBCONTRACTOR": "Link to subcontractor",
    "LINK_TO_SUBCONTRACTOR_API": "Link to subcontractor - API",
    "apiLinkEmail": "Subcontractor link email",
    "licensePlates": "License plates",
    "licensePlates.break": "License<br/>plates",
    "transportEntity": "Transport entity",
    "logisticMinimum": "Logistic minimum",
    "logisticMinimumSurcharge": "Logistic min. surcharge",
    "countryImport": "Import to AT",
    "countryExport": "Export outside AT",
    "weightReceipt": "Weight receipt",
    "Projects.ViewProject.closestPickupTime": "Closest pickup time:",
    "staticCalendar": "Static calendar",
    "dynamicCalendar": "Dynamic calendar",
    "billingPeriodOccurrences": "Occurrences in the billing period",
    "calendar": "Calendar",
    "calendar.FIRST_OCCURRENCE": "First occurrence",
    "calendar.SECOND_OCCURRENCE": "Second occurrence",
    "calendar.THIRD_OCCURRENCE": "Third occurrence",
    "calendar.FOURTH_OCCURRENCE": "Fourth occurrence",
    "calendar.FIFTH_OCCURRENCE": "Fifth occurrence",
    "recipientCalendar": "Recipient calendar",
    "frequency": "Frequency",
    "frequency.ONE_WEEK": "Every week",
    "frequency.TWO_WEEKS": "Every 2 weeks",
    "frequency.THREE_WEEKS": "Every 3 weeks",
    "frequency.FOUR_WEEKS": "Every 4 weeks",
    "frequency.FIVE_WEEKS": "Every 5 weeks",
    "serviceStartDate": "Service start date",
    "monday": "Mon",
    "tuesday": "Tue",
    "wednesday": "Wed",
    "thursday": "Thu",
    "friday": "Fri",
    "saturday": "Sat",
    "sunday": "Sun",
    "GlobalSettings.infrastructure.header": "Infrastructure types",
    "GlobalSettings.infrastructure.tooltip.delete": "If infrastructure is used, system will not allow to remove it.",
    "GlobalSettings.wastes": "Wastes",
    "GlobalSettings.wastes.tooltip.delete": "If waste is used, system will not allow to remove it.",
    "GlobalSettings.wastes.header": "List waste codes",
    "GlobalSettings.fixedAssets": "Fixed assets",
    "GlobalSettings.fixed-assets.header": "Interzero's infrastructure",
    "GlobalSettings.navResources": "BC resources",
    "GlobalSettings.exchangeRates": "Exchange rates & PIX",
    "GlobalSettings.exchangeRates.euroDaily": "Euro - daily",
    "GlobalSettings.exchangeRates.euroMonthly": "Euro - monthly",
    "Registers": "Registers",
    "Registers.projectPerson": "People in projects",
    "organizationUsers": "Organization users",
    "Button.InfrastructureModel.add": "Add new resource",
    "Button.InfrastructureModel.add.dialog.title": "Adding new infrastructure",
    "Button.InfrastructureModel.edit.dialog.title": "Editing infrastructure",
    "Button.OrganizationInfrastructureModel.add": "Add new  fixed resource",
    "Button.OrganizationInfrastructureModel.add.dialog.title": "Adding new fixed resource",
    "Button.WasteModel.add": "Add waste code",
    "Button.WasteModel.add.dialog.title": "Adding waste code",
    "wasteName": "Waste name",
    "Button.WasteModel.edit.dialog.title": "Editing waste code",
    "Button.NavResourceModel.add": "Add BC resource",
    "Button.NavResourceModel.add.dialog.title": "Adding BC resource",
    "Button.NavResourceModel.edit.dialog.title": "Editing BC resource",
    "Button.ExchangeRateModel.add": "Add value",
    "Button.ExchangeRateModel.add.dialog.title": "Adding new daily value",
    "Button.ExchangeRateModel.add.pix.dialog.title": "Adding new PIX value",
    "Button.ExchangeRateModel.add.monthly.dialog.title": "Adding new monthly average value",
    "Button.ExchangeRateModel.edit.dialog.title": "Editing daily value",
    "Button.ExchangeRateModel.edit.pix.dialog.title": "Editing PIX value",
    "Button.ExchangeRateModel.edit.monthly.dialog.title": "Editing monthly average value",
    "Button.ProjectPerson.add": "Add new person",
    "Button.ProjectPerson.add.dialog.title": "Adding new person for projects",
    "Button.ProjectPerson.edit.dialog.title": "Editing person for projects",
    "Button.ProjectInfrastructureModel.edit.dialog.title": "Edit resource",
    "Breadcrumb.home": "Home",
    "Breadcrumb.companies": "Companies",
    "Breadcrumb.maps": "Maps",
    "Breadcrumb.settings": "Settings",
    "Breadcrumb.project": "Project",
    "Breadcrumb.projects": "Projects",
    "Breadcrumb.registers": "Registers",
    "Breadcrumb.companies.new-company": "New company",
    "Breadcrumb.projects.new-project": "New project",
    "Breadcrumb.global-settings": "Settings",
    "Breadcrumb.month-end-closing": "Month-end closing",
    "Breadcrumb.organization-users": "Organization Users",
    "Breadcrumb.collection-requests": "Collection requests",
    "Breadcrumb.contact-form": "Contact form",
    "Breadcrumb.reports": "Reports",
    "Breadcrumb.client-data": "Client data",
    "Breadcrumb.communes": "Communes",
    "Breadcrumb.commune-declarations": "Commune declarations",
    "Breadcrumb.pickups": "Pickups",
    "Breadcrumb.today-pickups": "Today's pickups",
    "Breadcrumb.quantity-received": "Quantities received",
    "Breadcrumb.agreements": "Agreements",
    "Breadcrumb.decisions": "Decisions",
    "Breadcrumb.branches": "Branches",
    "Breadcrumb.infrastructure": "Infrastructure",
    "Breadcrumb.archive": "Archive",
    "Breadcrumb.user-manual": "Manual",
    "Breadcrumb.documents": "Documents",
    "Breadcrumb.services-to-accept": "Services to accept",
    "companies": "Companies",
    "maps": "Maps",
    "settings": "Settings",
    "projects": "Projects",
    "registers": "Registers",
    "AppBar.logout": "Logout",
    "AppBar.changeLanguage": "Change language",
    "SmartDataTable.of": "of",
    "SmartDataTable.numberOfItems": "Rows on page",
    "SmartDataTable.search": "Search",
    "SmartDataTable.noData": "There are no records to display",
    "addFilter": "Add filter",
    "yes": "Yes",
    "no": "No",
    "Button.confirmationTitle": "Confirmation required",
    "Button.confirmationCancel": "Cancel",
    "Button.confirmationMsg": "Are you sure to continue?",
    "Button.confirmationProceed": "Ok, proceed",
    "Common.cancel": "Cancel",
    "save": "Save",
    "edit": "Edit",
    "Common.error": "Error.. try again later",
    "Common.error.unique-error": "Data duplication error. Value is already in the database",
    "Common.error.validation-error": "Validation error, server rejected form's data.",
    "Common.delete": "Delete",
    "Common.back": "Back",
    "Common.show": "Show",
    "Common.loading": "Loading...",
    "Common.select": "Select",
    "Common.noData": "No data",
    "Model.User.active": "Active",
    "Model.User.managesUsers": "Manages users",
    "Model.User.assignsProjectNumber": "Assigns project name",
    "Model.User.viewsUnassignedProjects": "Views unassigned projects",
    "wasteCode": "Waste code",
    "Model.Waste.type": "Type of waste",
    "ownDescriptionOfWaste": "Own description of waste",
    "Model.Waste.code.required": "Waste code is required",
    "wasteDescription": "Waste description",
    "Model.Waste.description.required": "Waste description is required",
    "Model.Waste.hazardous": "Hazardous waste",
    "Model.Waste.hazardousProperties": "Hazardous properties",
    "Model.Waste.selectHazardousProperties": "Select hazardous properties",
    "Model.Waste.hazardousPropertyCode": "Code",
    "Model.Waste.hazardousPropertyName": "Name",
    "Model.Waste.nonWaste": "Not a waste",
    "Model.Infrastructure.category": "Infrastructure category",
    "Model.Infrastructure.category.required": "Infrastructure category is required",
    "estimatedMassMg": "Estimated mass (t)",
    "estimatedMass": "Estimated mass",
    "Model.Infrastructure.mass.required": "Estimated mass is required",
    "volumeM3": "Volume",
    "volumeM3.required": "Volume is required",
    "volumeM3.matches": "Volume must contain only numbers",
    "resourceName": "Resource",
    "Model.Infrastructure.name.required": "Resource is required",
    "collectionMethod": "Creates resource",
    "container": "Container",
    "Model.Infrastructure.InfrastructureCategory.DUMPSTER": "Dumpster",
    "Model.Infrastructure.InfrastructureCategory.ROLL_OFF_CONTAINER": "Roll-off container",
    "Model.Infrastructure.InfrastructureCategory.BARREL": "Barrel",
    "Model.Infrastructure.InfrastructureCategory.BALER": "Baler",
    "Model.Infrastructure.InfrastructureCategory.STATIONARY_PRESS": "Stationary press",
    "Model.Infrastructure.InfrastructureCategory.BIG_BAG": "Big bag",
    "Model.Infrastructure.InfrastructureCategory.PRESS_CONTAINER": "Press container",
    "Model.Infrastructure.InfrastructureCategory.PALLET": "Pallet",
    "Model.Infrastructure.InfrastructureCategory.BAG": "Bag",
    "Model.Infrastructure.InfrastructureCategory.LOOSE": "Loose",
    "Model.Infrastructure.InfrastructureCategory.IBC": "IBC",
    "Model.Infrastructure.InfrastructureCategory.TANK": "Tank",
    "Model.Infrastructure.InfrastructureCategory.BIN": "Bin",
    "Model.Infrastructure.InfrastructureCategory.GITTERBOX": "Gitterbox",
    "Model.Infrastructure.InfrastructureCategory.PALOXE": "Paloxe",
    "Model.Infrastructure.InfrastructureCategory.ASP": "ASP",
    "Model.Infrastructure.InfrastructureCategory.ALL": "All",
    "Model.OrganizationInfrastructure.generatedNumber": "Fixed asset id",
    "Model.OrganizationInfrastructure.deprecation": "Deprecation",
    "Model.OrganizationInfrastructure.deprecationMonths": "Deprecation period",
    "Model.OrganizationInfrastructure.deprecationAmount": "Deprecation amount",
    "Model.OrganizationInfrastructure.deprecationStartDate": "Begin of deprecation",
    "Model.OrganizationInfrastructure.deprecationRate": "Deprecation rate (%)",
    "Model.OrganizationInfrastructure.serialNumber": "Type / Serial no",
    "Model.OrganizationInfrastructure.serialNumber.required": "Type / Serial no is required",
    "Model.ExchangeRateModel.rate": "Value",
    "Model.ExchangeRateModel.rate.monthly": "Monthly value",
    "Model.ExchangeRateModel.rate.PIX": "PIX value",
    "Model.ExchangeRateModel.rate.required": "Value is required",
    "Model.ExchangeRateModel.date": "Date",
    "Model.ExchangeRateModel.date.required": "Date is required",
    "Model.NavResource.code": "Code / Nr",
    "Model.NavResource.code.required": "Kod / Nr is required",
    "Model.NavResource.name.required": "Name is required",
    "type": "Type",
    "Model.NavResource.type.required": "Type is required",
    "Model.NavResource.type.HARDWARE": "Hardware",
    "Model.NavResource.type.EMPLOYEE": "Employee",
    "unitLong": "Unit",
    "Model.NavResource.unit.required": "Unit type is required",
    "Model.NavResource.unit.MG": "Ton",
    "Model.NavResource.unit.UNIT": "Unit",
    "Model.NavResource.unit.SERVICE": "Service",
    "Model.NavResource.price": "Unit price",
    "Model.NavResource.price.required": "Unit price is required",
    "Model.NavResource.accountingGroup": "Main commodity accounting group",
    "Model.NavResource.accountingGroup.required": "Main commodity accounting group is required",
    "Model.NavResource.accountingGroup.CONSULTANCY": "Consultancy",
    "Model.NavResource.accountingGroup.COMMODITY": "Commodity",
    "Model.NavResource.accountingGroup.SERVICES": "Other services",
    "Model.NavResource.accountingGroup.RSI": "RSI",
    "companyName": "Company name",
    "Model.Company.name.required": "Company name is required",
    "Model.Company.vatin.required": "USt-ID is required",
    "nationalCourtRegister": "MB",
    "nationalCourtRegister.matches": "MB must contain only numbers",
    "Model.Company.mpdNumber": "MPD Number",
    "buyerNumber": "Buyer's number",
    "creditor": "Creditor",
    "debitor": "Debitor",
    "subcontractor": "Subcontractor",
    "houseNum": "House num.",
    "apartmentNum": "Apartment num.",
    "province": "Province",
    "country": "Country",
    "Model.Company.address.keeper": "Keeper",
    "registrationAddress": "Registration address",
    "correspondenceAddress": "Correspondence address",
    "addressInformation": "Address information",
    "contactPerson": "Contact person",
    "notApplicable": "Not applicable",
    "paymentPeriod": "Payment for the period",
    "paymentPeriod.MONTH": "month",
    "paymentPeriod.TWO_MONTHS": "two months",
    "paymentPeriod.QUARTER": "quarter",
    "paymentPeriod.YEAR": "year",
    "paymentPeriod.NOT_APPLICABLE": "not applicable",
    "paymentDay": "Payment by the day",
    "paymentDay.DAY_LAST": "last day of month",
    "paymentDue": "Payment in",
    "paymentDue.FIRST_MONTH": "in the first month",
    "paymentDue.SECOND_MONTH": "in the second month",
    "paymentDue.THIRD_MONTH": "in the third month",
    "paymentDue.AFTER_BILLING_PERIOD": "after the billing period",
    "paymentDue.BILLING_PERIOD_LAST_MONTH": "in the last month of the billing period",
    "paymentDue.NOT_APPLICABLE": "not applicable",
    "resolutionContainerPrice": "Container rate according to the resolution",
    "resolutionPaymentPeriod": "Payment for the period according to the resolution",
    "nextPaymentDate": "Closest payment date",
    "calculatedPrice": "Payment Amount",
    "bankAccountNumber": "Account number",
    "bankPaymentReceiver": "Payee",
    "bankPaymentTitle": "Transfer title",
    "collectionDecisionNotRequired": "No decision required",
    "Model.Company.groupOfCompanies": "Group of Companies",
    "Model.CompanyBranch.name": "Branch name",
    "Model.CompanyBranch.name.required": "Branch name is required",
    "correspondenceAddressEqRegistrationAddress": "Correspondence address is the same as registration address",
    "Model.CompanyBranch.data": "Branch data",
    "clientsServices": "Clients/Services",
    "quantityReceived": "Quantity received",
    "quantityReceivedPieces": "Quantity received (pieces)",
    "volumeReceived": "Volume received",
    "agreements": "Agreements",
    "decisionsConclusions": "Decisions/Conclusions",
    "decisions": "Decisions",
    "conclusions": "Conclusions",
    "archive": "Archive",
    "others": "Others",
    "general": "General",
    "companyShortName": "Company short name",
    "Model.CompanyBranch.accessionDate": "Accesion date",
    "Model.CompanyBranch.subcontractorType": "Subcontractor type",
    "Model.CompanyBranch.transporting": "Transporting",
    "Model.CompanyBranch.collecting": "Collecting",
    "Model.CompanyBranch.capturing": "Capturing",
    "Model.CompanyBranch.other": "Other",
    "Model.CompanyBranch.collectorOfMunicipialWaste": "Collector of municipial waste",
    "platformSettings": "Platform settings",
    "perMonth": "Per month",
    "Model.CompanyBranch.perReceipt": "Per receipt",
    "Model.ProjectClient.payoff": "Aggregate monthly settlement (default for new services)",
    "Model.ProjectClient.billingSettings": "BILLING SETTINGS",
    "Model.ProjectClient.paymentMethod": "Payment method",
    "Model.ProjectClient.paymentConditions": "Payment conditions",
    "Model.ProjectPerson.name": "First and last name",
    "Model.ProjectPerson.name.required": "First and last name is required",
    "invoicingPerson": "Invoicing person",
    "invoicingPerson.required": "Invoicing person is required",
    "projectNumberRequired": "Project number is required",
    "salesperson": "Salesperson",
    "salesperson.required": "Salesperson is required",
    "projectNum": "Project number",
    "Model.Project.data": "DATA",
    "Model.Project.projectNumber.required": "Project number is required",
    "Model.Project.name.required": "Project name is required",
    "projectType": "Project type",
    "Model.Project.type.TRADING": "Trading",
    "Model.Project.type.ONE_TIME": "One time",
    "Model.Project.type.OTHER": "Other",
    "Model.Project.type.required": "Project type is required",
    "Model.Project.projectNameForSubcontractor": "Name for subcontractor",
    "Model.Project.projectNameForSubcontractor.required": "Name for subcontractor is required",
    "Model.Project.selectMainCompany": "Select main company",
    "Model.Project.selectMainCompany.required": "Main company is required",
    "Model.Project.mainCompanyName": "Main company",
    "projectLeadPerson": "Project leader",
    "projectLeadPerson.required": "Project leader is required",
    "projectName": "Project name",
    "role": "Role",
    "category": "Category",
    "description": "Description",
    "mass": "Mass",
    "massMg": "Mass [t]",
    "receivedMass": "Received mass",
    "Model.ProjectInfrastructure.selectInfrastructure": "Select infrastructure",
    "Model.ProjectSubcontractors.monthlyPayoff": "Monthly payoff",
    "Model.ProjectSubcontractors.agreements": "Subcontractors Agreements",
    "settlementPeriod": "Settlement Period",
    "settled": "Settled",
    "SETTLED": "Settled",
    "wasteServiceCode": "Waste/Service Code",
    "wasteNameServiceDesc": "Waste name/Service description",
    "infrastructureContainer": "Infrastructure(container)",
    "Model.Terms.projectSettings": "Project and Headquarters Settings",
    "Error.CommuneUsed": "Commune and province are used by company",
    "Error.CommuneExists": "Commune and province already exists",
    "dropFileUpload": "Upload a file by dropping it here or click and add one file",
    "assignedProjects": "Assigned projects",
    "mpdStatus": "MPD Status",
    "joined": "Joined",
    "owner": "Owner",
    "assignProjects": "Assign projects",
    "selectProjects": "Select projects",
    "assign": "Assign",
    "sharedWithBranches": "Shared with branches",
    "projectNumberAndName": "Project number and name",
    "clientName": "Client name",
    "numberOfContainers": "Number of containers",
    "containerPrice": "Container price",
    "priceType": "Price type",
    "priceType.M3": "m3",
    "priceType.UNIT": "unit(s)",
    "priceType.MG": "t",
    "priceType.HOUR": "hour",
    "transportPriceType": "Transport (price type)",
    "receiptSubcontractorPriceType": "Receipt (subcontractor price type)",
    "priceReception": "Price reception",
    "daysOfTheWeek": "Days of the week",
    "year": "Year",
    "modificationDate": "Modification date",
    "uploadDate": "Upload date",
    "settlementType": "Settlement type",
    "settlementType.PER_MONTH": "Per month",
    "PER_MONTH": "Per month",
    "settlementType.PER_COLLECTION": "Per collection",
    "PER_COLLECTION": "Per collection",
    "settlementStatus": "Settlement status",
    "reportDate": "Report date",
    "reportDateFrom": "Report date from",
    "reportDateTo": "Report date to",
    "implementationDate": "Implementation date",
    "implementationDateFrom": "Implementation date from",
    "implementationDateTo": "Implementation date to",
    "orderNum": "Order num.",
    "orders": "Orders",
    "reportedWeight": "Reported weight",
    "reportedWeightExceed": "Reported exceed (weight)",
    "estimatedQuantities": "Estimated quantities",
    "reportedQuantities": "Reported quantities",
    "reportedQuantitiesExceed": "Reported exceed (quantities)",
    "reportedExceed": "Reported exceed",
    "selectFromList": "Select from list",
    "addedDate": "Added date",
    "status": "Status",
    "decisionsOnCollecting": "Collection decisions",
    "otherDecisions": "Other decisions",
    "expirationDate": "Expiration date",
    "transfer": "Transfer",
    "14days": "14 days",
    "price": "Price",
    "m3": "m3",
    "unit": "unit",
    "mg": "t",
    "currency": "Currency",
    "byWeight": "By weight (t)",
    "prepayment": "Prepayment",
    "fixedAsset": "Fixed asset",
    "fixedAssetNumber": "Fixed asset number",
    "is": "IZ",
    "volume": "Volume",
    "projectInfrastructure": "Project infrastructure",
    "projectInfrastructureService": "Project infrastructure service",
    "shared": "Shared",
    "containerAmount": "Container amount",
    "lease": "Lease",
    "leasePriceClient": "Lease price (client)",
    "leasePriceSubcontractor": "Lease price (subcontractor)",
    "priceFrom": "Price from",
    "addRegionalAdmin": "Add Regional Admin account",
    "addAdmin": "Add admin",
    "addNewDocument": "Add new document",
    "commercialDocument": "Commercial document",
    "addKeeper": "Add keeper",
    "addUserAccount": "Add user account",
    "addNewCommune": "Add new commune",
    "addLoginAccount": "Add login account",
    "addNew": "Add new",
    "addNewService": "Add new service",
    "addBranchInfrastructureService": "Add new branch infrastructure service",
    "addNewInfrastructure": "Add new infrastructure",
    "importFromExcel": "Import from Excel",
    "customerKeepers": "Customer keepers",
    "subcontractorKeepers": "Subcontractor keepers",
    "acceptElectronicInvoices": "Acceptance of electronic invoices",
    "einvoicesSendingContacts": "Contacts for e-invoice sending",
    "einvoices": "E-invoices",
    "reportSendingContacts": "Contacts for sending reports",
    "orderContacts": "Contacts for orders",
    "download": "Download",
    "changeSubcontractorPrices": "Change subcontractor prices",
    "editContactPerson": "Edit contact person",
    "attentionLeasePriceMessage": "Attention! You will change the infrastructure lease price on the Client Branch Card on the Project.",
    "monthEndClosing": "Month-end closing",
    "servicesSettlement": "Settlement of services",
    "incomeInvoices": "Income invoices",
    "costInvoices": "Cost invoices",
    "unsettled": "Unsettled",
    "UNSETTLED": "Unsettled",
    "forApproval": "For approval",
    "FOR_APPROVAL": "For approval",
    "invoiced": "Invoiced",
    "INVOICED": "Invoiced",
    "canceled": "Canceled",
    "CANCELED": "Canceled",
    "onRequest": "On request",
    "isServices": "IZ Services",
    "uploadWeightReceipt": "Upload weight receipt",
    "transportCompleted": "Transport completed",
    "transferSettlement": "Transfer settlement to different month",
    "complain": "Complain",
    "complaint": "Complaint",
    "hasComplaint": "Has complaint",
    "cancelSettlement": "Cancel settlement",
    "sendToNav": "Send to BC",
    "settle": "Move to settled",
    "settleMassDiscrepancyErrorInfo": "Mass discrepancy error. Are you sure you wish to continue?",
    "discard": "Discard",
    "uploadNoncomplianceProtocol": "Upload non-compliance protocol",
    "column": "Column",
    "dateSentToNav": "Date sent to BC",
    "settlementCanceled": "Settlement canceled",
    "complaintIsSettled": "The complaint is settled",
    "unsettledServices": "Unsettled services",
    "canceledServices": "Canceled services",
    "systemRemoveSettlement": "Do you want the system to REMOVE THIS SETTLEMENT FROM THE RECORDS?",
    "yesDelete": "Yes, delete",
    "selectSettlementMonth": "Select month to which you want to assign service settlement",
    "settlementServiceCompleteData": "To SETTLEMENT SERVICE, complete data",
    "settlementSuccessfullyTransfered": "Successfully transfered your settlement to a different settlement period",
    "january": "January",
    "february": "February",
    "march": "March",
    "april": "April",
    "may": "May",
    "june": "June",
    "july": "July",
    "august": "August",
    "september": "September",
    "october": "October",
    "november": "November",
    "december": "December",
    "shortMonth.01": "Jan",
    "shortMonth.02": "Feb",
    "shortMonth.03": "Mar",
    "shortMonth.04": "Apr",
    "shortMonth.05": "May",
    "shortMonth.06": "Jun",
    "shortMonth.07": "Jul",
    "shortMonth.08": "Aug",
    "shortMonth.09": "Sep",
    "shortMonth.10": "Oct",
    "shortMonth.11": "Nov",
    "shortMonth.12": "Dec",
    "next": "Next",
    "transportPlan": "Transport plan",
    "companyData": "Company data",
    "fillComplaintData": "To make a COMPLAINT, fill the data",
    "complainedMass": "Amount of mass to be complained",
    "complainedQuantities": "Quantities to be complained",
    "editActiveFields": "You can EDIT active fields",
    "reasonForChange": "Reason for change",
    "croatia": "Croatia",
    "editData": "Edit data",
    "headquarter": "Headquarter",
    "headquarterName": "Headquarter name",
    "fieldRequired": "Field required",
    "positiveNumberRequired": "Positive number required",
    "notNegativeNumberRequired": "Not negative number required",
    "numberRequired": "Value must be a number",
    "fullName": "Full name",
    "accountActive": "Account active",
    "requiredValidEmail": "Required valid email",
    "requiredValidEmails": "Required valid emails, separated by a comma",
    "accountActivationEmailSent": "Account activation email sent",
    "selectBranch": "Select branch",
    "selectCompany": "Select company",
    "placeOfWork": "Place of work",
    "streetRequired": "Street name is required",
    "houseNumRequired": "House number is required",
    "localityRequired": "Locality is required",
    "postcodeRequired": "Postcode is required",
    "postcodeInvalid": "You can use only numbers and a dash",
    "rights": "Rights",
    "enterValueThenPressEnter": "Enter value, then press \"Enter\" key",
    "ballerOutputMass": "Ball mass [t]",
    "activationDate.required": "Activation date is required",
    "subcontractor.required": "Subcontractor is required",
    "containerAmount.required": "Container amount is required",
    "leasePrice.required": "Lease price is required",
    "reportsReport": "Pickups / Orders",
    "reportPickup": "Report pickup",
    "reportsV2": "Order status & contact forms",
    "reportsV2.collectionRequests": "Order status",
    "declarationChanges": "Declaration changes",
    "financialReports": "Financial reports",
    "monthEndClosingReports": "Month end closing reports",
    "loginReports": "Login reports",
    "otherReports": "Others",
    "ReportType.FINANCIAL_INCOME_AND_COSTS": "Income and costs report",
    "ReportType.FINANCIAL_MONTHLY": "Financial report: Monthly",
    "ReportType.FINANCIAL_ANNUAL": "Financial report: Annual",
    "ReportType.SUBCONTRACTOR": "Subcontractor price report",
    "ReportType.FINANCIAL_MONTHLY_ACHIEVEMENTS": "Financial report: Monthly achievements",
    "ReportType.MONTH_CLOSING_MISSING_INVOICES": "Month closing: Missing invoices",
    "OtherReportType.SUBCONTRACTOR_DECISIONS": "Subcontractor decisions",
    "OtherReportType.INFRASTRUCTURES": "Infrastructures report",
    "OtherReportType.NO_FORM": "NO obrazac (waste generation)",
    "reportFile": "Report file",
    "contactForms": "Contact forms",
    "contactForm": "Contact form",
    "showServices": "Show services",
    "servicesList": "Services list",
    "backToBranchesList": "Back to company branches list",
    "pickupsInProgress": "Pickups in progress",
    "inProgress": "In progress",
    "receiptSizeUnit": "Receipt size (units)",
    "clientPrice": "Client price",
    "subcontractorPrice": "Subcontractor price",
    "recipient": "Recipient",
    "sendPickupRequest": "Send PICKUP REQUEST",
    "tonnesOfwaste": "Mass of waste in tonnes",
    "tonnesOfwaste.matches": "Mass of waste must be a number greater than 0.",
    "noContainersForPickup": "Number of containers to be picked up",
    "noContainersForPickup.matches": "Number of containers can only have numbers",
    "noContainersForPickup.exceeded": "Number of containers available for this service {{maxContainers}}",
    "branchCity": "Branch city",
    "branchStreet": "Branch street",
    "concerns": "Concerns",
    "collectionRequestType.PICKUP": "Pickup request",
    "collectionRequestType.SCHEDULE": "Schedule",
    "collectionRequestType.NO_PICKUP": "No pickup",
    "collectionRequestType.EXCEED": "Exceed",
    "invoiceNumber": "Invoice number",
    "open": "Open",
    "history": "History",
    "done": "Done",
    "pickupDate": "Pickup date",
    "previousValue": "Previous value",
    "previousValueMg": "Previous value t",
    "previousNumberOfTransports": "Previous number of transports",
    "numberOfTransports": "Number of transports",
    "newValue": "New value",
    "newValueMg": "New value t",
    "newNumberOfTransports": "New number of transports",
    "author": "Author",
    "details": "Details",
    "senderLogin": "Sender login",
    "senderClient": "Sender client",
    "senderBranch": "Sender branch",
    "sender": "Sender",
    "dateSent": "Date sent",
    "message": "Message",
    "previousMonth": "Previous month",
    "nextMonth": "Next month",
    "reportTimeRange": "Report time range",
    "forPeriod": "For period",
    "initialMonth": "Initial month",
    "finalMonth": "Final month",
    "reportStatus": "Report status",
    "decisionStatus": "Decision status",
    "SubcontractorDecisionStatus.ALL": "All",
    "SubcontractorDecisionStatus.MISSED": "Missed",
    "SubcontractorDecisionStatus.VALID": "Valid",
    "SubcontractorDecisionStatus.EXPIRED": "Expired",
    "openReports": "Open reports",
    "closedReports": "Closed reports",
    "reportType": "Report type",
    "noPickup": "No pickup",
    "reportMissedPickup": "Report missed pickup",
    "reported": "Reported",
    "excessReported": "Excess reported",
    "reportAccepted": "Report accepted",
    "pickupOnHolidays": "Pickup on holidays",
    "pickupRequest": "Pickup request",
    "serviceRequest": "Service request",
    "generateReport": "Generate raport",
    "requiredField": "Required field",
    "fieldToLong": "Field too long",
    "many": "Many",
    "editProjectWaste": "Edit waste in project",
    "addPrice": "Add price",
    "show": "Show",
    "addContact": "Add contact",
    "sequences": "Sequences",
    "addSequence": "Add sequence",
    "editSequence": "Edit sequence",
    "mask": "Mask",
    "mask.help": "#LP#, #ROK#, #MIESIAC#, #DZIEN# ex.: FV/#ROK#/#LP# will generate FV/2023/1",
    "repeats": "Repeats",
    "nextTry": "Next try",
    "errorMessage": "Error message",
    "resourceExists": "Resource already exists",
    "search": "Find",
    "seesPrices": "Sees prices",
    "organizationIsParticipating": "Organization takes part in project",
    "clientLease": "Lease - Client",
    "subcontractorLease": "Lease - Subcontractor",
    "noPackage": "Not packaged",
    "projectInfrastructureDescription": "Project infrastructure description",
    "infrastructureDescription": "Infrastructure description",
    "showAllCards": "Show all cards",
    "showCards": "Show cards",
    "plannedTransportTime": "Planned transport time",
    "realTransportTime": "Transport time",
    "initialMass": "Initial mass",
    "initialMass.break": "Initial</br>mass",
    "senderEupNumber": "Sender MPD number",
    "senderEupName": "Sender MPD name",
    "receiver": "Receiver",
    "receiverEupNumber": "Receiver MPD number",
    "receiverEupName": "Receiver MPD name",
    "carrierIdentificationNumber": "Carrier id number",
    "cardRejectionTime": "Card rejection time",
    "withdraw": "Withdraw",
    "reason": "Reason",
    "revise": "Revise",
    "mutually-exclusive": "Mutually exclusive",
    "activationDateBefore": "Activation date before",
    "activationDateAfter": "Activation date after",
    "deactivationDateBefore": "Deactivation date before",
    "deactivationDateAfter": "Deactivation date after",
    "serviceId": "Service ID",
    "more": "More",
    "assignBranchAccount": "Assign branch account",
    "remove": "Remove",
    "contractConclusionDate": "Contract conclusion date",
    "updateCompanyCentralBranch": "Update central branch",
    "branchNestedNumber": "No.",
    "reportForClient": "Report for client",
    "reportGenerated": "was generated",
    "reportNotGeneratedMessage": "Error occurred while generating report",
    "dateCannotBeBeforeActivationDate": "Date cannot be before activation date",
    "remarks": "Remarks",
    "receiverFirstAndLastName": "Receiver",
    "carrierName": "Carrier name",
    "communeDeclarations": "Commune declarations",
    "allProjects": "All projects",
    "importLogs": "Imports history",
    "uploadNewImportFile": "Upload new import file",
    "settlementImportStarted": "Settlement import started",
    "settlementImportFinished": "Settlement import finished",
    "settlementImportError": "Settlement import error",
    "settlementExportStarted": "Settlement export started",
    "settlementExportFinished": "Settlement export finished",
    "settlementExportError": "Settlement export error",
    "rowNumber": "Row number",
    "columnAddress": "Column",
    "filters": "Filters",
    "exportAndImportLogs": "Export and import history",
    "exportId": "Export id",
    "yearMonth": "Year and month",
    "false": "No",
    "true": "Yes",
    "delayedEmailNotification": "Delayed email notification",
    "sendActivationMailToUsers": "Send activation mail to users",
    "resendActivationMailToUser": "Resend activation mail to user",
    "resendActivationMailToActiveUserError": "Active user cannot receive activation mail",
    "messageContent": "Message content",
    "dropOrSelectAttachment": "Upload file by dropping here or select one",
    "selectedPeriod": "Selected period",
    "contactFormCreated": "Contact form created",
    "containerType": "Container type",
    "containerTypeDescription": "Check what the container looks like:",
    "emailForNotifications": "Email for notifications",
    "emailForEInvoice": "Email for e-invoice",
    "pickups": "Pickups",
    "todayPickups": "Today's pickups",
    "showPickups": "Show pickups",
    "upcomingPickupsDates": "Upcoming pickups dates",
    "pickupFrequency": "Pickup frequency",
    "reportExceed": "Report exceed",
    "reportingExceed": "Reporting exceed",
    "exceedAmount": "Exceed amount",
    "pickupRequestSuccess": "Pickup request sent successfully",
    "problemOccurrence": "Problem occurrence",
    "transportingSubcontractor": "Transporting subcontractor",
    "receivingSubcontractor": "Receiving subcontractor",
    "CARD_CONFIRMATION_GENERATED": "Confirmation generated",
    "CARD_RECEIVE_CONFIRMATION": "Receive confirmation",
    "CARD_TRANSPORT_CONFIRMATION": "Transport confirmation",
    "CARD_REJECTED": "Rejected",
    "CARD_WITHDRAWN": "Withdrawn",
    "GENERAL_ERROR": "Error occurred",
    "INVALID_DATE": "Invalid date",
    "datesMustBeInSameYear": "Dates must be in the same year",
    "from": "From",
    "to": "To",
    "user-manual": "Manual",
    "documents": "Documents",
    "filesToDownload": "Files to download",
    "servicesToAccept": "Services to accept",
    "serviceWaitingAcceptation": "Service waiting for acceptation",
    "makeAvailableToBranch": "Make available to the branch",
    "availableToBranch": "Available to the branch",
    "branchesImported.title": "Summary of branches import",
    "branchesImported.content": "Created {{createdCount}}, updated {{updatedCount}}",
    "branchesImported.errorRowsInfo": "Errors in rows:",
    "branchesImportIOError": "Error while reading excel file",
    "incorrectNumberOfSheets": "Incorrect number of sheets in excel file",
    "reportGenerationStarted": "Report generation started",
    "receivedQuantitiesImport.started": "Import of received quantities started",
    "receivedQuantitiesImport.success": "Import of received quantities finished successfully",
    "receivedQuantitiesImport.error": "Error while importing received quantities",
    "receivedQuantitiesImport.errorWithRow": "Error while importing received quantities. Check row {{rowNumber}}",
    "receivedQuantitiesImport.errorWithRowColumn": "Error while importing received quantities. Check row {{rowNumber}}, column {{columnAddress}}",
    "reportGeneration.inProgress": "In progress",
    "reportGeneration.failed": "Error",
    "reportGeneration.noData": "No data",
    "onlyPlatformMpds": "Only MPDs from the platform",
    "clientPoiInstruction": "Instruction",
    "NEW_YEAR_DAY": "New Year's Day",
    "EPIPHANY": "Epiphany",
    "EASTER_MONDAY": "Easter Monday",
    "LABOUR_DAY": "Labour Day",
    "ASCENSION_DAY": "Ascension Day",
    "WHIT_MONDAY": "Whit Monday",
    "CORPUS_CHRISTI": "Corpus Christi",
    "ASSUMPTION_DAY": "Assumption Day",
    "NATIONAL_DAY": "National Day",
    "ALL_SAINTS_DAY": "All Saints' Day",
    "IMMACULATE_CONCEPTION": "Immaculate Conception",
    "CHRISTMAS_DAY": "Christmas Day",
    "ST_STEPHEN_DAY": "St. Stephen's Day",
    "onDemandPickups": "Cyclical pickups",
    "onDemandPickupsDescription": "This table contains information about municipal waste, without a defined collection schedule or with a frequently changing schedule. The \"report excess\" button is used to inform the recipient of an increased/above-normal amount of waste to be collected on the next collection. The amount of reported excesses is summed up during the month in the \"reported excess\" column.",
    "onDemandSettlements": "On demand settlements",
    "exceedWillBeSummedWarning": "WARNING: The excess will be aggregated with previous submissions for this service within this month",
    "addInvoiceNumberAndCommentProcessStarted": "Process of adding invoice number and comment started",
    "upToXDays": "up to {{days}}",
    "companiesList": "Companies list",
    "branchesList": "Branches list",
    "resourceInBulk": "Loose",
    "loadingTimeClientPrice": "Loading time client",
    "loadingTimeSubcontractorPrice": "Loading time subcontractor",
    "feesClientPrice": "Fees client",
    "feesSubcontractorPrice": "Fees subcontractor",
    "fireProtectionClientPrice": "Fire protection client",
    "fireProtectionSubcontractorPrice": "Fire protection subcontractor",
    "loadingTime": "Loading time, hours",
    "includeLoadingPrices": "Include loading prices",
    "includeFeesPrices": "Include fees prices",
    "includeFireProtectionPrices": "Include fire protection prices",
    "addNewContactForBranchLink": "Add new contact for the branch",
    "sendDelayedActivationMailWarning": "Activation mail will be sent to all inactive users with 'Delayed email notification' turned on. Continue?",
    "collectionRequestDoneMessage": "Collection request marked as completed",
    "downloadCard": "Download the waste manifest",
    "nkdClass": "NKD class",
    "transportAuthority": "Transport authority",
    "authority": "Authority",
    "reportContainersAmountForPickupWithCreatesResourceOnlyInfrastructureWarning": "If using a baler - enter the number of bales",
    "otherPhysicalProperty": "Other physical property",
    "customWasteDescription": "Custom waste description",
    "otherWastePackaging": "Other waste packaging",
    "packageNumber": "Package number",
    "wastePhysicalPropertyType": "Physical property type",
    "wastePhysicalPropertyType.DUST": "Dust",
    "wastePhysicalPropertyType.SOLID": "Solid",
    "wastePhysicalPropertyType.PASTY": "Pasty",
    "wastePhysicalPropertyType.SLUDGE": "Sludge",
    "wastePhysicalPropertyType.LIQUID": "Liquid",
    "wastePhysicalPropertyType.GASEOUS": "Gaseous",
    "wastePhysicalPropertyType.OTHER": "Other",
    "wastePackagingType": "Packaging type",
    "wastePackagingType.BULK": "Bulk",
    "wastePackagingType.VESSEL": "Vessel",
    "wastePackagingType.CONTAINER": "Container",
    "wastePackagingType.BUCKET": "Bucket",
    "wastePackagingType.CANISTER": "Canister",
    "wastePackagingType.BARREL": "Barrel",
    "wastePackagingType.BOX": "Box",
    "wastePackagingType.BAG": "Bag",
    "wastePackagingType.OTHER": "Other",
    "reportOnWasteProcessing": "Report on waste processing",
    "wasteFlowPurpose": "Purpose",
    "wasteFlowPurpose.USE": "Use",
    "wasteFlowPurpose.DISPOSAL": "Disposal",
    "wasteFlowQuantityMethod": "Quantity method",
    "wasteFlowQuantityMethod.QUANTITY_WEIGHING": "Quantity weighing",
    "wasteFlowQuantityMethod.QUANTITY_ESTIMATE": "Quantity estimate",
    "wasteFlowTransportMethod": "Transport method",
    "wasteFlowTransportMethod.ROAD": "Road",
    "wasteFlowTransportMethod.RAIL": "Rail",
    "wasteFlowTransportMethod.SEA": "Sea",
    "wasteFlowTransportMethod.AIR": "Air",
    "wasteFlowTransportMethod.INLAND_WATERWAYS": "Inland waterways",
    "senderDateOfDelivery": "Sender date of delivery",
    "wasteFlowLicensePlates": "License plates (waste flow)",
    "carrierReceivedBy": "Carrier received by",
    "carrierDeliveryDate": "Carrier delivery date",
    "carrierSubmittedBy": "Carrier submitted by",
    "recipientReceivedBy": "Recipient received by",
    "recipientDateOfWeighing": "Recipient date of weighing",
    "recipientQuantityTakenInKg": "Recipient quantity taken (kg)",
    "exportLogs": "Export history",
    "financialReportPeriod.CUSTOM": "Custom",
    "financialReportPeriod.MONTHLY": "Monthly",
    "messageDetails": "Message details",
    "pixSettlementDay": "PIX settlement unit",
    "pixSettlementDay.DAILY_COLLECTION_DAY_CURRENT_DAY": "Current day",
    "pixSettlementDay.DAILY_COLLECTION_DAY_PREVIOUS_DAY": "Previous day",
    "pixSettlementDay.DAILY_LAST_DAY_CURRENT_MONTH": "Last day of the current month",
    "pixSettlementDay.DAILY_LAST_DAY_PREVIOUS_MONTH": "Last day of the previous month",
    "pixSettlementDay.MONTHLY_CURRENT_MONTH": "Average EUR rate of the current month",
    "pixSettlementDay.MONTHLY_PREVIOUS_MONTH": "Average EUR rate of the previous month",
    "project": "Project",
    "reportPeriod": "Report period",
    "reportsSendingContacts": "Contacts for sending reports",
    "sumMonths": "Sum of months",
    "LoginPage.generalTermsAndConditions": "General terms and conditions",
    "LoginPage.privacyPolicy": "Privacy policy",
    "userWithoutAssignedRole": "User without an assigned role",
    "plannedFeature": "Planned feature - this screen is a preview, data will appear once it ships.",
    "featureNotImplemented": "This feature is not implemented yet.",
    "cancelOrder": "Cancel order",
    "cancellingOrder": "Cancelling collection request",
    "cancellationReason": "Reason for cancellation",
    "cancellationReasonHint": "The reason is sent to the subcontractor if they have already received the order.",
    "collectionRequestCancelledMessage": "Collection request cancelled",
    "collectionRequestDeletedMessage": "Collection request deleted",
    "cancelledBy": "Cancelled by",
    "cancelDate": "Cancellation date",
    "deleteOrder": "Delete order",
    "deleteOrderConfirmation": "The order will be permanently deleted and will not appear in reports. Continue?",
    "confirm": "Confirm",
    "unexpectedError": "An unexpected error occurred.",
    "cancel": "Cancel"
  },
  "error": {
    "E00001": "Error.. try again later",
    "E00002": "Validation error",
    "E00003": "Invalid request argument",
    "E00004": "Database save failed",
    "E00005": "Database save failed - duplicate would be created",
    "E01001": "Not authorized to assign project number",
    "E02001": "Infrastructure count exceeded",
    "E02002": "Collection requests with date after deactivation date were found",
    "E02003": "Invalid activation date or date of service start",
    "E03001": "Settlements afflicted by price change contain complaints",
    "E04001": "Company already used as a subcontractor",
    "Error.ResourceUsed": "Resource is in use",
    "Error.ResourceActive": "Resource is not deactivated",
    "Error.ProjectInfrastructureNeedsMass": "Infrastructure mass is required",
    "Error.AggregateReplayRunningException": "Portal is down due to maintenance works, please try again in few minutes",
    "Error.ResourceExists": "Resource already exists",
    "Error.DeactivateFailedActiveServicesExist": "Cannot deactivate, active services exist or services are planned",
    "Error.MissingScheduleFields": "Collection days not selected",
    "Error.MissingRequiredRdrFile": "Missing subcontractor's RDR file related to client's commune",
    "Error.CannotDeleteSettlement": "Action would cause removal of settled settlement",
    "Error.InfrastructureServiceNotYetActive": "Attached infrastructure service is not yet active",
    "Error.CannotDeactivateNotZeroSettlementsExists": "Not zero declarations exists after deactivation date",
    "Error.InfrastructureNotExistsException": "Infrastructure does not exists",
    "Error.CollectionOutsideServiceActiveDate": "Collection date outside service active period",
    "Error.CollectionForDeactivatedService": "Service is deactivated",
    "Error.CannotRejectServiceWithSettlements": "Cannot reject service with settlements",
    "Error.GeneralSettlementExcelError": "Settlement export/import error",
    "Error.SettlementReadWrite": "Settlement read/write error",
    "Error.SettlementImportNoSheet": "No sheet 'Usluge' in the file",
    "Error.SettlementImportMissingId": "Missing 'Id' column in the file",
    "Error.ProjectBranchInfrastructureServiceHasInvoicedSettlement": "Project branch infrastructure service has invoiced settlement",
    "Error.ProjectBranchServiceHasSettledOrInvoicedSettlement": "Project branch service has settled or invoiced settlement",
    "Error.OnDemand.NotScheduledServiceType": "On demand service can be scheduled type only",
    "Error.OnDemand.NotPerMonthSettlementType": "On demand service can be per month settlement type only",
    "Error.OnDemand.ProvidedCalendarSchedule": "On demand service cannot have provided calendar schedule",
    "Error.OnDemand.ConstantCost": "On demand service cannot have constant cost",
    "Error.OnDemand.NonMunicipalWaste": "On demand service can be municipal waste type only",
    "Error.HazardousWasteSettlementType": "Hazardous waste service can be per request settlement type only",
    "Error.HazardousWasteEmptyLicensePlates": "Hazardous waste service cannot have empty license plates",
    "Error.NoEmailToNotifyAboutCollectionRequest": "Error! The order cannot be registered due to lack of an email for orders. Please contact your Interzero POI supervisor immediately",
    "Error.CannotChangePriceForInvoicedServiceSettlements": "Cannot change price for invoiced service settlements for current or future months",
    "Error.UserHasNoAssignedProject": "You don't have an assigned project, please contact with Interzero",
    "Error.CollectionRequestAlreadyFinished": "This collection request has already been completed, reported as missed or cancelled, so it can no longer be changed.",
    "Error.CollectionRequestSettlementLocked": "This collection request belongs to a settlement that is already settled, invoiced or awaiting acceptance. For monthly settlements this covers every request of that month.",
    "Error.CollectionRequestCancellationWindowExpired": "The time window for cancelling this collection request has passed. Please contact Interzero.",
    "Error.CollectionRequestNotCancellableServiceType": "Collection requests of this service type cannot be cancelled.",
    "Error.CollectionRequestNotCancelled": "Only a cancelled collection request can be deleted. Cancel it first.",
    "Error.CollectionRequestNotAccessible": "This collection request does not belong to your company."
  }
}
